<template>
    <div
        class="form-toggle"
        :class="{checked: !!value, invalid: invalid, disabled: disabled}"
        @click.stop="toggle"
    >
        <div
            class="form-toggle--true"
            :class="{active: !!value}"
        >
            Tak
        </div>
        <div
            class="form-toggle--false"
            :class="{active: !value}"
        >
            Nie
        </div>
        <input
            type="checkbox"
            :name="name"
            :value="true"
            v-model="inputValue"
            title=""
        />
    </div>
</template>

<script>
    export default {
        name: "FormToggle",
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                inputValue: false
            }
        },
        created() {
            this.inputValue = this.value
        },
        methods: {
            toggle () {
                if (!this.disabled) {
                    this.inputValue = !this.inputValue
                    this.$emit('input', this.inputValue)
                    console.log('toggle', this.inputValue)
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/_variables/color";

    .form-toggle {
        width: 74px;
        height: 32px;
        border: 2px solid $color-primary;
        border-radius: 32px;
        display: inline-block;
        position: relative;
        cursor: pointer;
        transition: .2s;
        vertical-align: top;
        font-size: 10px;

        > div {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            font-size: 16px;
            line-height: 1;
            padding: 6px 0.7em;
            z-index: 1;
            opacity: 0;
            transition: .2s opacity;
            &.active {
                opacity: 1;
            }
        }

        input {
            // visibility: hidden;
            opacity: 0;
        }

        &:after {
            content: url('~@/assets/images/icons/icon_close_o.png');
            vertical-align: middle;
            display: inline-block;
            position: absolute;
            right: 2px;
            top: 2px;
            width: 24px;
            height: 24px;
            background-color: $color-primary;
            z-index: 2;
            border-radius: 50%;
            transition: .3s;
            transform: translateX(-70px + 24 + 4);
            text-align: center;
        }

        &.checked {
            border-color: $color-positive;
            background-color: $color-positive;
            &:after {
                content: url('~@/assets/images/icons/icon_check_positive_o.png');
                background-color: #fff;
                transform: translateX(0);
            }
        }

        &.disabled {
            opacity: .8;
            cursor: default;
        }

        &.invalid {
            border-color: $color-error;
        }


        &--true {
            color: #fff;
            text-align: left;
        }

        &--false {
            color: $color-primary;
            text-align: right;
        }


    }
</style>
